<div class="m-h">
  <b class="a-10 u-c d-xs">{{ "bet.title" | mnTranslate }}</b>
  <mn-button aEvent="calculator_modal_close" (clicked)="close()">
    <mn-svg class="st-e" name="close" />
  </mn-button>
</div>
<mn-calculator [prefix]="prefix" [precision]="precision" [min]="data.min" [max]="data.max" [(amount)]="amount" />
<mn-button aEvent="calculator_modal_ok" radius="r-24" size="large" type="success" (clicked)="close(true)"
  ><b class="u-c d-xs">{{ "btn.ok" | mnTranslate }}</b></mn-button
>
